export var Gender;

(function (Gender) {
  Gender["female"] = "female";
  Gender["male"] = "male";
})(Gender || (Gender = {}));

export var PersonalizedSupplementStatus;

(function (PersonalizedSupplementStatus) {
  PersonalizedSupplementStatus["safe"] = "safe";
  PersonalizedSupplementStatus["risky"] = "risky";
  PersonalizedSupplementStatus["dangerous"] = "dangerous";
})(PersonalizedSupplementStatus || (PersonalizedSupplementStatus = {}));

export var _3D_VENDER;

(function (_3D_VENDER) {
  _3D_VENDER["tg3d"] = "TG3D";
  _3D_VENDER["visbody"] = "Visbody";
})(_3D_VENDER || (_3D_VENDER = {}));

export var EquipBrand;

(function (EquipBrand) {
  EquipBrand[EquipBrand["_3D"] = process.env.NEXT_PUBLIC_ENVIRONMENT === 'china' ? _3D_VENDER.visbody : _3D_VENDER.tg3d] = "_3D";
  EquipBrand["InBody"] = "InBody";
  EquipBrand["imedtac"] = "imedtac";
})(EquipBrand || (EquipBrand = {}));

export var ClientProfileTabType;

(function (ClientProfileTabType) {
  ClientProfileTabType["todo"] = "todo";
  ClientProfileTabType["journal"] = "journal";
  ClientProfileTabType["buyTimeline"] = "buyTimeline";
  ClientProfileTabType["survey"] = "survey";
  ClientProfileTabType["measurement"] = "measurement";
  ClientProfileTabType["target"] = "target";
  ClientProfileTabType["personal"] = "personal";
  ClientProfileTabType["dietRecord"] = "dietRecord";
  ClientProfileTabType["weekSummary"] = "weekSummary";
  ClientProfileTabType["clientInfo"] = "clientInfo";
  ClientProfileTabType["clientRecord"] = "clientRecord";
  ClientProfileTabType["courseSummary"] = "courseSummary";
})(ClientProfileTabType || (ClientProfileTabType = {}));

export var MainTitle;

(function (MainTitle) {
  MainTitle["bodyMass"] = "body-mass";
  MainTitle["inspectionReport"] = "inspection-report";
  MainTitle["report3D"] = "report-3D";
  MainTitle["abdominalUltrasound"] = "abdominal-ultrasound";
  MainTitle["diagnosis"] = "diagnosis";
  MainTitle["timeline"] = "timeline";
  MainTitle["clientQuestionnaire"] = "client-questionnaire";
  MainTitle["uploadFile"] = "upload-file";
  MainTitle["bloodSugar"] = "blood-sugar";
  MainTitle["ordersList"] = "orders_list";
  MainTitle["phalanx"] = "phalanx";
  MainTitle["therapy"] = "therapy";
})(MainTitle || (MainTitle = {}));

export var StatusType;

(function (StatusType) {
  StatusType["success"] = "success";
  StatusType["statusBlue"] = "statusBlue";
  StatusType["statusPink"] = "statusPink";
  StatusType["statusGray"] = "statusGray";
  StatusType["statusPurple"] = "statusPurple";
  StatusType["statusWhite"] = "statusWhite";
  StatusType["error"] = "error";
  StatusType["disabled"] = "disabled";
  StatusType["warn"] = "warn";
})(StatusType || (StatusType = {}));

export var AccountType;

(function (AccountType) {
  AccountType["user"] = "User";
  AccountType["client"] = "Client";
})(AccountType || (AccountType = {}));

export var ChatRoomStatus;

(function (ChatRoomStatus) {
  ChatRoomStatus["archived"] = "archive";
  ChatRoomStatus["activate"] = "activate";
  ChatRoomStatus["deactivate"] = "deactivate";
})(ChatRoomStatus || (ChatRoomStatus = {}));

export var ChatRoomRawType;

(function (ChatRoomRawType) {
  ChatRoomRawType["personal"] = "personal";
  ChatRoomRawType["groupClass"] = "group_class";
  ChatRoomRawType["advancedGroup"] = "advanced_group";
})(ChatRoomRawType || (ChatRoomRawType = {}));

export var ChatRoomType;

(function (ChatRoomType) {
  ChatRoomType["personal"] = "personal";
  ChatRoomType["group"] = "group";
})(ChatRoomType || (ChatRoomType = {}));

export var ChatRoomInfoType;

(function (ChatRoomInfoType) {
  ChatRoomInfoType["member"] = "member";
  ChatRoomInfoType["memo"] = "memo";
  ChatRoomInfoType["template"] = "template";
  ChatRoomInfoType["ai"] = "ai";
  ChatRoomInfoType["gallery"] = "gallery";
  ChatRoomInfoType["etc"] = "etc";
})(ChatRoomInfoType || (ChatRoomInfoType = {}));

export var SocketStatus;

(function (SocketStatus) {
  SocketStatus["connected"] = "connected";
  SocketStatus["closed"] = "closed";
})(SocketStatus || (SocketStatus = {}));

//only for CI test
export var SurveyType;

(function (SurveyType) {
  SurveyType["INIT_SURVEY_ID"] = "INIT_SURVEY_ID";
  SurveyType["HORMONES_SURVEY_ID"] = "HORMONES_SURVEY_ID";
  SurveyType["SUPPLEMENT_SURVEY_ID"] = "SUPPLEMENT_SURVEY_ID";
  SurveyType["SUPPLEMENT_FEEDBACK_SURVEY_ID"] = "SUPPLEMENT_FEEDBACK_SURVEY_ID";
  SurveyType["SUPPLEMENT_RETURN_SURVEY_ID"] = "SUPPLEMENT_RETURN_SURVEY_ID";
  SurveyType["W2_FEEDBACK_SURVEY_ID"] = "W2_FEEDBACK_SURVEY_ID";
  SurveyType["W5_FEEDBACK_SURVEY_ID"] = "W5_FEEDBACK_SURVEY_ID";
  SurveyType["ADVANCE_PLAN_SURVEY_ID"] = "ADVANCE_PLAN_SURVEY_ID";
  SurveyType["ADCT_SURVEY_ID"] = "ADCT_SURVEY_ID";
  SurveyType["FOLLOW_UP_FEEDBACK_SURVEY_ID"] = "FOLLOW_UP_FEEDBACK_SURVEY_ID";
  SurveyType["ONE_ON_ONE_CONSULTING_SATISFACTION_SURVEY_ID"] = "ONE_ON_ONE_CONSULTING_SATISFACTION_SURVEY_ID";
  SurveyType["SUPPLEMENT_SATISFACTION_SURVEY_ID"] = "SUPPLEMENT_SATISFACTION_SURVEY_ID";
  SurveyType["SUPPLEMENT_FOLLOW_UP_SATISFACTION_SURVEY_ID"] = "SUPPLEMENT_FOLLOW_UP_SATISFACTION_SURVEY_ID";
  SurveyType["W8_FIRST_SURVEY_ID"] = "W8_FIRST_SURVEY_ID";
  SurveyType["W8_SUBSEQUENT_SURVEY_ID"] = "W8_SUBSEQUENT_SURVEY_ID";
})(SurveyType || (SurveyType = {}));

export var SurveyRegion;

(function (SurveyRegion) {
  SurveyRegion["TW"] = "tw";
  SurveyRegion["CN"] = "cn";
  SurveyRegion["CNHQ"] = "cnhq";
})(SurveyRegion || (SurveyRegion = {}));

export var SurveyCategory;

(function (SurveyCategory) {
  SurveyCategory["ADULT"] = "adult";
  SurveyCategory["CHILD"] = "child";
})(SurveyCategory || (SurveyCategory = {}));

export var BranchVisitStates;

(function (BranchVisitStates) {
  BranchVisitStates[BranchVisitStates["created"] = 0] = "created";
  BranchVisitStates[BranchVisitStates["reserved"] = 1] = "reserved";
  BranchVisitStates[BranchVisitStates["checked_in"] = 2] = "checked_in";
  BranchVisitStates[BranchVisitStates["skipped"] = 3] = "skipped";
  BranchVisitStates[BranchVisitStates["canceled"] = 4] = "canceled";
  BranchVisitStates[BranchVisitStates["aborted"] = 5] = "aborted";
  BranchVisitStates[BranchVisitStates["finished"] = 9] = "finished";
})(BranchVisitStates || (BranchVisitStates = {}));

export var RoleType;

(function (RoleType) {
  RoleType["COFIT_ADMIN_ROLE"] = "admin";
  RoleType["COFIT_CUSTOMER_SERVICE_ROLE"] = "customer_service";
  RoleType["COFIT_CHAT_MESSAGE_MANAGER_ROLE"] = "chat_message_manager";
  RoleType["COFIT_ASSISTANT_ROLE"] = "assistant";
  RoleType["COFIT_CLIENT_ROLE"] = "client";
  RoleType["COFIT_ACCOUNTING_ROLE"] = "accounting";
  RoleType["COFIT_ASSISTANT_DIETICIAN_ROLE"] = "assistant_dietician";
  RoleType["COFIT_EXPERT_ROLE"] = "expert";
  RoleType["COFIT_DIETICIAN_ROLE"] = "dietician";
  RoleType["COFIT_GROUP_CLASS_DIETICIAN_ROLE"] = "group_class_dietician";
  RoleType["COFIT_MASTER_DIETICIAN_ROLE"] = "master_dietician";
  RoleType["COFIT_SECOND_ASSISTANT_ROLE"] = "second_assistant";
  RoleType["COFIT_PHR_READER_ROLE"] = "phr_reader";
  RoleType["COFIT_EDITOR_ROLE"] = "editor";
  RoleType["COFIT_OPERATOR_ROLE"] = "operator";
  RoleType["COFIT_REPORT_VIEWER_ROLE"] = "report_viewer";
  RoleType["COFIT_WRITER_ROLE"] = "writer";
  RoleType["COFIT_SURVEY_VIEWER_ROLE"] = "survey_viewer";
  RoleType["COFIT_SURVEY_EDITOR_ROLE"] = "survey_editor";
  RoleType["COFIT_REFERRAL_CODE_PM_ROLE"] = "referral_code_pm";
  RoleType["COFIT_MESSAGE_TEMPLATE_ROLE"] = "message_template_editor";
  RoleType["COFIT_DIETICIAN_INTERN_ROLE"] = "dietician_intern";
  RoleType["CLINIC_DOCTOR_ROLE"] = "clinic::doctor";
  RoleType["CLINIC_BRANCH_MANAGER_ROLE"] = "clinic::branch_manager";
  RoleType["CLINIC_CUSTOMER_SERVICE_ROLE"] = "clinic::customer_service";
  RoleType["CLINIC_SENIOR_CUSTOMER_SERVICE_ROLE"] = "clinic::senior_customer_service";
  RoleType["CLINIC_INVENTORY_MANAGE_ROLE"] = "clinic::inventory_manager";
  RoleType["CLINIC_NURSE_ROLE"] = "clinic::nurse";
  RoleType["CLINIC_DIETICIAN_ROLE"] = "clinic::dietician";
  RoleType["CLINIC_PHARMACIST_ROLE"] = "clinic::pharmacist";
  RoleType["CLINIC_SALESPERSON_ROLE"] = "clinic::salesperson";
  RoleType["CLINIC_APPOINTMENT_SPECIALIST_ROLE"] = "clinic::appointment_specialist";
  RoleType["CLINIC_ASSISTANT_ROLE"] = "clinic::assistant";
  RoleType["CLINIC_THERAPIST_ROLE"] = "clinic::therapist";
  RoleType["CLINIC_ACCOUNTING_ROLE"] = "clinic::accounting";
})(RoleType || (RoleType = {}));

export var ClientStatus;

(function (ClientStatus) {
  ClientStatus[ClientStatus["updated"] = 0] = "updated";
  ClientStatus[ClientStatus["normal"] = 1] = "normal";
})(ClientStatus || (ClientStatus = {}));

export var OrderSource;

(function (OrderSource) {
  OrderSource[OrderSource["his"] = 0] = "his";
  OrderSource[OrderSource["group_class"] = 1] = "group_class";
  OrderSource[OrderSource["pos"] = 2] = "pos";
})(OrderSource || (OrderSource = {}));

export var BodyMassSource;

(function (BodyMassSource) {
  BodyMassSource[BodyMassSource["all"] = 0] = "all";
  BodyMassSource[BodyMassSource["inBody"] = 1] = "inBody";
  BodyMassSource[BodyMassSource["genesis"] = 2] = "genesis";
  BodyMassSource[BodyMassSource["growth"] = 3] = "growth";
})(BodyMassSource || (BodyMassSource = {}));

export * from './branches';
export * from './diet';
export * from './drug';
export * from './formGenerator';
export * from './InstantFoodTool';
export * from './memo';
export * from './menu';
export * from './product';
export * from './soap';
export * from './store';
export * from './utils';